/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { CTA_TYPE } from '././defs.js';
import { descriptor as parentDescriptor } from '../link-with-icon/link-with-icon.js';
import { propTypes as parentPropTypes } from '../link-with-icon/link-with-icon.js';
export { default as CustomElement } from '../../components/cta/text-cta.js';
import createReactCustomElementType, {
  numberSerializer,
} from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = Object.assign({}, parentDescriptor, {
  ctaType: {
    attribute: 'cta-type',
  },
  formatVideoCaption: {
    attribute: false,
  },
  formatVideoDuration: {
    attribute: false,
  },
  videoDuration: {
    serialize: numberSerializer,
    attribute: 'video-duration',
  },
  videoName: {
    attribute: 'video-name',
  },
  videoDescription: {
    attribute: 'video-description',
  },
});
export var propTypes = {
  /**
   * The CTA type.
   */
  ctaType: PropTypes.string,
  /**
   * The formatter for the video caption, composed with the video name and the video duration.
   * Should be changed upon the locale the UI is rendered with.
   */
  formatVideoCaption: PropTypes.string,
  /**
   * The formatter for the video duration.
   * Should be changed upon the locale the UI is rendered with.
   */
  formatVideoDuration: PropTypes.string,
  /**
   * The video duration.
   */
  videoDuration: PropTypes.number,
  /**
   * The video name.
   */
  videoName: PropTypes.string,
  /**
   * The video description.
   */
  videoDescription: PropTypes.string,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-text-cta'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
